module.exports = __webpack_public_path__ + "static/media/bottom-left-card.5e0f6e31.png";